import React from "react";
import { render } from "react-dom";
import { OnboardingStart } from "./components/OnboardingStart";
import { MetaTagsComponent } from "./components/MetaTagsComponent";
import { PixeledFont } from "./styled-components/PixeledFont";
import { analyticsEvent } from "./utils/analytics";

const renderOnboardingStart = (extensionInstalled) => {
  console.log("rendering");
  render(
    <React.Fragment>
      <PixeledFont />
      <MetaTagsComponent />
      <OnboardingStart extensionInstalled={extensionInstalled} />
    </React.Fragment>,
    document.getElementById("crx_root")
  );
};

const isExtensionInstalled = () => {
  let img = new Image();
  img.src = "chrome-extension://jlgkpaicikihijadgifklkbpdajbkhjo/icon.png";
  img.onload = () => {
    let event = new CustomEvent("getExtensionVersion");
    console.log("event", event);
    document.addEventListener("responseGetExtensionVersion", (e) => {
      console.log("responseGetExtensionVersion", e);
      localStorage.getItem(
        "extensionVersion",
        localStorage.getItem("extensionVersion")
      );

      if (localStorage.getItem("extensionVersion") === null) {
        localStorage.setItem("extensionVersion", e.detail.version);
        analyticsEvent("Main KPIs", "Extension installed");
      }
      renderOnboardingStart(true);
    });
    document.dispatchEvent(event);
  };
  img.onerror = () => {
    renderOnboardingStart(false);
  };
};

isExtensionInstalled();
